import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import RefreshContext from "../RefreshContext";
import SummaryTable from "./SummaryTable";
import BarChart from "./BarChart";
import Category from "./Category";
import PieChart from "./PieChart";
import Dollars from "./Dollars";
import Transactions from "./Transactions";
import withParams from "../lib/withParams";
import ColumnHeader from "./ColumnHeader";
import apiClient from "../lib/apiClient";

export default function Categories({ dataViewId, accountId }) {
  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState(null);
  const [total, setTotal] = useState(0);
  const [totalPerMonth, setTotalPerMonth] = useState(0);

  const { refreshKey } = useContext(RefreshContext);

  useEffect(() => {
    const fetchCategories = async () => {
      const path = withParams("/api/categories", { dataViewId, accountId });

      const { data } = await apiClient.get(path);

      const { categories, total, total_per_month } = data;

      // calculate the percentage of the total for each category
      categories.forEach(category => {
        category.percent_of_total = category.total_amount / total;
      });
      setCategories(categories);
      setTotal(total);
      setTotalPerMonth(total_per_month);

    };
    fetchCategories();
  }, [refreshKey, dataViewId, accountId]);

  useEffect(() => {
    // sometimes on refresh, the selected category goes away from this 
    // view and we should reset it if it's not in the list
    if (!categories?.find(c => c?.id === category?.id)) {
      setCategory(null);
    }
  }, [categories, category]);


  if (!categories) return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </div>
  );
  if (categories.length === 0) return (
    <div>
      <ColumnHeader title="No Data Found" />
      <p>
        No transactions found for this time period. Select a different time range.
      </p>
    </div>
  )
  return (
    <div className={"row gx-3"}>
      <div className={"col-4"}>
        <div className="card p-4 pt-2">

          {<ColumnHeader title="Categories" />}
          {categories && <SummaryTable
            rows={categories}
            onRowClick={category => {
              setCategory(category)
            }}
            selectedRow={category}
            columns={[
              { title: "Category", value: (row) => row.name || 'Uncategorized' },
              { title: "Total", value: "total_amount", type: "currency" },
              { title: "%", value: "percent_of_total", type: "percent" }
            ]} />}
        </div>
      </div>
      <div className={"col-8"}>
        <div className="card p-4 pt-2">
          {category && <Category
            id={category.id}
            name={category.name}
            dataViewId={dataViewId}
            accountId={accountId}
            onClose={() => setCategory(null)}
          />}
          {!category && <Overview total={total} totalPerMonth={totalPerMonth} categories={categories} />}
        </div>
      </div>
    </div>
  )


  function Overview({ total, totalPerMonth, categories }) {
    const chartPath = withParams("/api/transactions/time_series_chart", { dataViewId, accountId });
    return (
      <div>
        <ColumnHeader title="Overview" />
        <div className={"row"}>
          <div className={"col-6"}>
            <h5>Total Cashflow</h5>
            <Dollars amount={total} />
          </div>
          <div className={"col-6"}>
            <h5>Average Monthly Cashflow</h5>
            <Dollars amount={totalPerMonth} />
          </div>
        </div>
        <hr />
        <div className={"row"}>
          <div className={"col-6"}>
            <BarChart title="Cashflow Trend"
              path={chartPath} />
          </div>
          <div className={"col-6"}>
            <PieChart title="Cashflow by Category"
              data={categories} />
          </div>
        </div>
        <hr />
        <h4>
          <Link className="text-dark" to={`/views/${dataViewId}#transactions`}>
            Transactions
          </Link>
        </h4>
        <Transactions dataViewId={dataViewId} accountId={accountId} limit={5} />
      </div>
    )
  }
}

